import { FC } from 'react';
import { StyledPlaceholder } from './styled';
import { PlaceholderImageVariant } from '@kl/components-v6/src/placeholder/types';

interface Props {
    title: string;
    description: string;
    buttonText?: string;
    onReload?: () => void;
    image?: PlaceholderImageVariant;
    hideButton?: boolean;
}

export const NothingToDisplay: FC<Props> = ({
    title,
    description,
    image,
    buttonText,
    onReload,
    hideButton,
}) => {
    return (
        <StyledPlaceholder
            description={description}
            image={image}
            title={title}
            actionButtons={
                hideButton
                    ? undefined
                    : [
                          {
                              testId: 'placeholderReloadButton',
                              text: buttonText,
                              mode: 'secondary',
                              onClick: onReload,
                          },
                      ]
            }
        />
    );
};
